import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IosWorkaroundService {
  public get isIosBrowser(): boolean {
    return [
     'iPad Simulator',
     'iPhone Simulator',
     'iPod Simulator',
     'iPad',
     'iPhone',
     'iPod'
   ].includes(navigator.platform)
   // iPad on iOS 13 detection
   || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
   || navigator.platform.toUpperCase().indexOf('MAC')>=0
 }
}
